import clsx from 'clsx';
import Head from 'next/head';

import styles from './EmbedWrapper.module.scss';

interface IPageWrapperProps {
  title?: string;
  description?: string;
  className?: string;
  mode?: 'light' | 'dark';
  children: React.ReactNode;
}

export const EmbedWrapper = ({
  title,
  children,
  className,
  mode = 'light',
  description,
}: IPageWrapperProps) => {
  return (
    <>
      <Head>
        {title && (
          <>
            <title>{title}</title>
            <meta content={title} key={title} property="og:title" />
          </>
        )}
        {description && (
          <>
            <meta content={description} key={description} name="description" />
            <meta
              content={description}
              key={description}
              property="og:description"
            />
          </>
        )}
      </Head>

      <div>
        <section className={clsx(styles.central, className)} data-mode={mode}>
          {children}
        </section>
      </div>
    </>
  );
};
